export default __webpack_public_path__ + "static/img/material-pattern.3e15f1c.jpg";